import { endpoint } from 'services/Api';
import { RESOURCE as PARENT } from 'services/api/calculatorModals';

/**
 * Resource Endpoint.
 *
 * @type {String}
 */
export const RESOURCE = 'multipliers';

/**
 * Multiplier Modal Endpoints:
 *     - Pre Assessment Multiplier Modal Endpoint.
 *     - Post Assessment Multiplier Modal Endpoint.
 *     - TableData 1 And 2 Multiplier Modal Endpoint.
 *     - TableData 28 Multiplier Modal Endpoint.
 */
export default {
    /**
     * Pre-Assessment Discount Multiplicand Modal Endpoint.
     *
     * @return {Promise}
     */
    preAssessment: data => endpoint(`${PARENT}/${RESOURCE}`, 'pre-assessment', data),
    /**
     * Post-Assessment Discount Multiplicand Modal Endpoint.
     *
     * @return {Promise}
     */
    postAssessment: data => endpoint(`${PARENT}/${RESOURCE}`, 'post-assessment', data),
    /**
     * Post-Assessment Multiplier Modal Endpoint.
     *
     * @return {Promise}
     */
    postAssessmentMultiplier: data => endpoint(`${PARENT}/${RESOURCE}`, 'post-assessment-multiplier', data),
    /**
     * Ogden TableData 1 and 2 Multipliers Modal Endpoint.
     *
     * @return {Promise}
     */
    table1And2: data => endpoint(`${PARENT}/${RESOURCE}`, 'table-1-and-2', data),
    /**
     * Ogden TableData 28 Multipliers Modal Endpoint.
     *
     * @return {Promise}
     */
    table28: data => endpoint(`${PARENT}/${RESOURCE}`, 'table-28', data),
    /**
     * Contingency multiplier Modal Endpoint.
     *
     * @return {Promise}
     */
    contingencyMultiplier: (data) => {
        data.claim.assumedSettlement = moment(data.claim.assumedSettlement, 'DD/MM/YYYY').format('YYYY-MM-DD');
        return endpoint(`${PARENT}/${RESOURCE}`, 'contingency-multiplier', data);
    },
    /**
     * Pre Injury Contingency multiplier Modal Endpoint.
     *
     * @return {Promise}
     */
    preInjuryContingencyMultiplierPayload: data => endpoint(`${PARENT}/${RESOURCE}`, 'pre-injury-contingency-multiplier', data),
    /**
     * Assessment Contingency multiplier Modal Endpoint.
     *
     * @return {Promise}
     */
    assessmentContingencyMultiplierPayload: data => endpoint(`${PARENT}/${RESOURCE}`, 'assessment-contingency-multiplier', data),
    /**
     * Purchase Multipliers Modal Endpoint.
     *
     * @return {Promise}
     */
    purchase: data => endpoint(`${PARENT}/${RESOURCE}`, 'purchase', data),
};



// WEBPACK FOOTER //
// ./src/services/api/calculatorModals/multipliers.js